import React from 'react';
import {Col, Container, Row, Accordion} from "react-bootstrap";

function Question(props) {
    return (
        <div className={props.color ? 'services_question bg_color p-100' : 'services_question p-100'}>
            <Container>
                <Row>
                    <Col xs={12} md={12} lg={8} xl={8} xxl={8} className="question_title">
                        <div className="example" data-text="FAQs">
                            <h2>Frequently Asked Questions</h2>
                        </div>
                    </Col>
                </Row>
                <Row>
                    <Col xs={12} md={12} lg={12} xl={12} xxl={12} className="services_faqs">
                        <Accordion defaultActiveKey="0">
                            <Accordion.Item eventKey="0">
                                <Accordion.Header>
                                    What Blockchain development services does TekRevol offer?
                                </Accordion.Header>
                                <Accordion.Body>
                                    <p>TekRevol offers a range of Blockchain development services, including designing and implementing Blockchain-based solutions, integrating Blockchain technology into existing systems, and developing custom Blockchain applications.</p>
                                    <p>Our team of experts can help you understand the potential applications of Blockchain technology in your business and develop a customized solution to meet your specific needs.</p>
                                </Accordion.Body>
                            </Accordion.Item>
                            <Accordion.Item eventKey="1">
                                <Accordion.Header>
                                    How much does Blockchain development cost, and what factors impact the price?
                                </Accordion.Header>
                                <Accordion.Body>
                                    <p>The cost of blockchain development will vary depending on the scope and complexity of the project. Some factors that can impact the price include the organizational size, the complexity of the solution, and the extent of the work required to integrate it. We offer competitive pricing and work with clients to identify cost-saving opportunities wherever possible. Contact us to discuss your specific needs and receive a customized quote.</p>
                                </Accordion.Body>
                            </Accordion.Item>
                        </Accordion>
                    </Col>
                </Row>
            </Container>
        </div>
    );
}

export default Question;